import { useMemo } from 'react';

import { useLoyaltyBadgesQuery } from 'generated/graphql-gateway';
import { useLocale } from 'state/intl';
import { useLoyaltyUserId } from 'state/loyalty/hooks/use-loyalty-user';

import { ILoyaltyBadge } from './types';

export const useGetLoyaltyBadges = ({ skip = false }: { skip?: boolean } = {}) => {
  const { language } = useLocale();
  const { loyaltyUserId } = useLoyaltyUserId();
  const { loading, data, error, refetch } = useLoyaltyBadgesQuery({
    variables: { loyaltyId: loyaltyUserId, where: { fetchAll: true } },
    skip: skip || !loyaltyUserId,
  });

  const badges: ILoyaltyBadge[] = useMemo(() => {
    return data?.loyaltyUserV2?.badges.map(badge => ({
      id: badge.id,
      earnedAt: badge.earnedAt,
      name: badge.name?.[language],
      description: badge.description?.[language],
      imageId: badge.image?.[language].imageUrl,
      imageAlt: badge.image?.[language].imageAlt,
      lottie: badge.lottie,
      shortDescription: badge.shortDescription?.[language],
      lockedCtaLink: badge.ctaLink?.[language],
      lockedCtaText: badge.ctaText?.[language],
    }));
  }, [language, data?.loyaltyUserV2?.badges]);

  return {
    badges,
    error,
    loading,
    refetch,
  };
};
